const originalFetch = window.fetch;
window.fetch = (url, options) => {
    return originalFetch(url, options).then(response => {
        let redirected = false;

        if (response.redirected && response.url.indexOf('signin') !== -1 && response.url.indexOf(gtxConstants.VHOST_URL_HOST) !== -1 && window.location.href.indexOf('/login/a2f') === -1) {
            redirected = true;
        }

        return new Promise((resolve, reject) => {
            if (redirected) {
                location.href = response.url;
                reject();
            } else {
                resolve(response);
            }
        });
    });
};
